import { useCallback, useEffect, useRef, useState } from 'react';

const DURACION_MS = 2600;

// Aviso breve abajo al centro ("Pedido enviado a cocina."). role=status para
// que los lectores de pantalla lo anuncien sin robar el foco.
export function useToast() {
  const [msg, setMsg] = useState<string | null>(null);
  const t = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const say = useCallback((m: string) => {
    clearTimeout(t.current);
    setMsg(m);
    t.current = setTimeout(() => setMsg(null), DURACION_MS);
  }, []);

  useEffect(() => () => clearTimeout(t.current), []);

  const nodo = msg ? (
    <div role="status" style={{
      position: 'fixed', left: '50%', bottom: 28, transform: 'translateX(-50%)', padding: '16px 24px',
      borderRadius: 12, background: 'var(--toast)', color: 'var(--on-strong)', fontSize: 17, fontWeight: 700,
      boxShadow: '0 12px 32px rgba(0,0,0,.25)', zIndex: 60, maxWidth: 'calc(100vw - 32px)',
    }}>{msg}</div>
  ) : null;

  return [nodo, say] as const;
}
